module.exports = __webpack_public_path__ + "img/product-3.dd371af1.png";